import { getActiveRegion, getActiveTenant, getDomainName } from 'api-client/helpers'
import { getInfraRegionURL } from '../secrets/actions'
import { sessionStoreKey } from 'core/session/sessionReducers'
import store from 'app/store'

/**
 * Returns the cluster endpoint for the given cluster name with current domain and tenant
 * @param param0 cluster name
 * @returns cluster endpoint
 */
export const getClusterEndpoint = ({ clusterName }) => {
  const hostname = new URL(getInfraRegionURL()).host
  const domain = getDomainName()
  const tenant = getActiveTenant()
  return String(`${clusterName}.${domain}-${tenant}.k8s.${hostname}`).toLowerCase()
}

export const isPrivateRegistryEnabled = () => {
  const state = store.getState()
  const { features } = state[sessionStoreKey]
  return features?.kaapi?.enable_private_registry === false ? false : true
}

interface KaapiClusterParams {
  name: string
  namespace: string
  hostedControlPlaneRefName: string
  infrastructureRefName: string
  version: string
  isBYOCluster?: boolean
  gpuAddons?: boolean
}

export const createKaapiClusterBody = ({
  name,
  namespace,
  hostedControlPlaneRefName,
  infrastructureRefName,
  version,
  isBYOCluster = false,
  gpuAddons = false,
}: KaapiClusterParams) => {
  // Get cas-capi-version from the version
  const casCapiVersion = `v${version
    .split('.')
    .slice(0, 2)
    .join('.')}`

  return {
    apiVersion: 'cluster.x-k8s.io/v1beta1',
    kind: 'Cluster',
    metadata: {
      name,
      namespace,
      labels: {
        'core-addons': 'enabled',
        'proxy-addons': 'enabled',
        'cas-capi-version': casCapiVersion,
        'pcd-kaapi.pf9.io/region': getActiveRegion(),
        ...(isBYOCluster
          ? { 'metrics-server': '0.6.4' }
          : { 'kaapi.pf9.io/infra-addon': 'openstack' }),
        ...(gpuAddons ? { 'gpu-addons': 'enabled' } : {}),
        ...(isPrivateRegistryEnabled() ? { 'private-registry': 'enabled' } : {}),
      },
    },
    spec: {
      clusterNetwork: {
        apiServerPort: 443,
        pods: {
          cidrBlocks: ['10.244.0.0/16'],
        },
        services: {
          cidrBlocks: ['10.96.0.0/16'],
        },
      },
      controlPlaneEndpoint: {
        host: `${getClusterEndpoint({ clusterName: name })}`,
        port: 443,
      },
      controlPlaneRef: {
        apiVersion: 'controlplane.platform9.io/v1alpha1',
        kind: 'HostedControlPlane',
        name: hostedControlPlaneRefName,
        namespace,
      },
      infrastructureRef: {
        apiVersion: 'infrastructure.cluster.x-k8s.io/v1beta1',
        kind: isBYOCluster ? 'ByoCluster' : 'OpenStackCluster',
        name: infrastructureRefName,
        namespace,
      },
    },
  }
}
